import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import contractPage from 'hoc/contractPage/contractPage';
import { PT_BR, EN } from 'utils/i18nUtils';

import ContractTemplate from '../patterns/ContractTemplate/ContractTemplate';

export function SecurityPolicy({ pageContent }) {
  const { formatMessage } = useIntl();

  return (
    <ContractTemplate title={formatMessage({ id: 'SECURITY_POLICY.HEAD.TITLE' })}>
      {/* eslint-disable-next-line react/no-danger */}
      <div dangerouslySetInnerHTML={{ __html: pageContent }} />
    </ContractTemplate>
  );
}

SecurityPolicy.propTypes = {
  pageContent: PropTypes.string.isRequired,
};

export default contractPage(SecurityPolicy, {
  routeKey: 'SECURITY_POLICY',
  googleDocumentId: {
    [EN]: '1ypRG8aRajDTU5F6pozT2OZ5LAhKD7eKlf2EKNJ997Sc',
    [PT_BR]: '1OsBYyQb1gtndsb8I0I5SJPNA1oXkbyuJIzrJIazEpPg',
  },
});
